// File: src/utils/fileToBase64.js

/**
 * Bir File nesnesini alır, FileReader ile DataURL (base64) string'e çevirir.
 * @param {File} file
 * @returns {Promise<string>}  // "data:<mime>;base64,AAA..."
 */
export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      // reader.result: "data:application/pdf;base64,JVBERi0xL..."
      resolve(reader.result);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsDataURL(file);
  });
}
